import { categories } from '@/mocks/siteData';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <h2 className="font-heading text-4xl md:text-5xl font-semibold text-foreground-950 tracking-tight">
            14 Smart Categories
          </h2>
          <p className="mt-3 text-base text-foreground-500">
            Curated for Western Buyers — every category organized with dedicated shopping sheets
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative flex flex-col items-center justify-center px-4 py-5 md:py-6 rounded-2xl transition-all duration-300 cursor-pointer ${
                cat.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 border border-background-200/70 text-foreground-800 hover:border-foreground-300 hover:bg-background-50'
              }`}
            >
              <span className={`text-sm md:text-base font-semibold whitespace-nowrap ${cat.hot ? '' : 'group-hover:text-foreground-950'}`}>
                {cat.name}
              </span>
              <span className={`text-xs mt-1.5 ${cat.hot ? 'text-background-50/70' : 'text-foreground-400 group-hover:text-foreground-500'}`}>
                {cat.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}